import { render } from "./index.vue?vue&type=template&id=def6cf62&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=def6cf62&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-def6cf62"

export default script